export default __webpack_public_path__ + "static/media/DZ.5d767efd.ico";